<template>
  <div>
    <v-container fluid>
      <v-card v-show="!loading">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Cadastro de Rodada</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn
            depressed
            color="primary lighten-3"
            class="ml-2"
            @click="$router.push('/rodadas')"
            v-if="!podeEditar(rodada.data_fim)"
            >Fechar</v-btn
          >
          <v-btn
            depressed
            color="primary lighten-3"
            class="ml-2"
            @click="$router.push('/rodadas')"
            :disabled="salvando"
            v-if="podeEditar(rodada.data_fim)"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary lighten-5"
            class="ml-2"
            @click="salvarRodada"
            :loading="salvando"
            :disabled="!form_valid"
            v-if="podeEditar(rodada.data_fim)"
            >Salvar</v-btn
          >
        </v-app-bar>
        <v-form ref="form" v-model="form_valid" lazy-validation>
          <v-container
            fluid
            class="pa-2 pb-4"
            :style="!podeEditar(rodada.data_fim) && 'pointer-events: none'"
          >
            <v-row v-show="loading">
              <v-col
                class="ma-6 pa-6"
                style="display: flex; align-items: center; justify-content: center; text-align: center"
              >
                <v-progress-circular
                  size="64"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" sm="6" class="px-3 py-0">
                <v-text-field
                  label="Nome"
                  ref="nome"
                  v-model="rodada.nome"
                  :rules="rules.nome"
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="px-3 py-0">
                <v-text-field
                  label="Local"
                  ref="local"
                  v-model="rodada.local"
                  :rules="rules.local"
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="3" class="px-3 py-0">
                <as-date-picker-menu
                  label="Data Início"
                  :disabled="user.tipo != 'master'"
                  ref="data_inicio"
                  :rules="rules.data_inicio"
                  v-model="rodada.data_inicio"
                  :readonly="user.tipo == 'administrador'"
                ></as-date-picker-menu>
              </v-col>
              <v-col cols="12" sm="3" class="px-3 py-0">
                <as-date-picker-menu
                  label="Data Fim"
                  :disabled="user.tipo != 'master'"
                  ref="data_fim"
                  :rules="rules.data_fim"
                  v-model="rodada.data_fim"
                  :readonly="user.tipo == 'administrador'"
                ></as-date-picker-menu>
              </v-col>
              <v-col cols="12" sm="3" class="px-3 py-0">
                <as-date-picker-menu
                  label="Data Veiculação"
                  ref="data_veiculacao"
                  :rules="rules.data_veiculacao"
                  v-model="rodada.data_veiculacao"
                ></as-date-picker-menu>
              </v-col>
              <v-col cols="12" sm="3" class="px-3 py-0">
                <as-date-picker-menu
                  label="Data Limite"
                  ref="data_limite"
                  :rules="rules.data_limite"
                  v-model="rodada.data_limite"
                ></as-date-picker-menu>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="5" class="px-3 py-0">
                <v-autocomplete
                  :items="estados"
                  label="Estado"
                  ref="estado"
                  :rules="rules.estado"
                  v-model="rodada.estado_id"
                  @change="carregarCidades"
                  autocomplete="off"
                  role="presentation"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="7" class="px-3 py-0">
                <v-autocomplete
                  :items="cidades"
                  label="Cidade"
                  ref="cidade"
                  :rules="rules.cidade"
                  v-model="rodada.cidade_id"
                  :loading="loadingCidades"
                  autocomplete="off"
                  role="presentation"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row dense v-if="user.tipo == 'master'">
              <v-col class="px-3 py-0">
                <v-autocomplete
                  :rules="rules.administrador"
                  ref="administrador"
                  :items="administradores"
                  v-model="rodada.administrador_id"
                  item-text="nome"
                  item-value="id"
                  label="Administrador"
                  no-data-text="Nenhum escolhido"
                  placeholder="Selecione..."
                  autocomplete="off"
                  role="presentation"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row dense v-if="user.tipo == 'administrador'">
              <v-col cols="12" sm="4" class="px-3 py-0">
                <v-card>
                  <v-img
                    :src="rodada.logo"
                    height="200px"
                    v-if="rodada.logo"
                    @click="$refs.dialogoLogo.abrir()"
                    style="cursor: pointer"
                  />
                  <v-layout
                    class="text-xs-center"
                    align-center
                    v-else
                    style="height:200px; background-color: lightgray; justify-content: center"
                  >
                    <v-icon large>image</v-icon>
                  </v-layout>

                  <v-card-title primary-title>
                    <div class="headline">Logo</div>
                    <v-spacer></v-spacer>
                    <v-btn
                      depressed
                      color="secondary darken-1"
                      type="file"
                      @click="abrirLogo"
                      v-show="podeEditar(rodada.data_fim)"
                      >Carregar</v-btn
                    >
                  </v-card-title>
                  <v-card-subtitle class="pt-2">
                    <span class="body-2"
                      >Carregue aqui a logo do seu evento</span
                    >
                    <br />
                    <span class="grey--text" v-if="rodada.logo"
                      >Clique na imagem para ampliá-la</span
                    >
                  </v-card-subtitle>
                </v-card>
                <input
                  type="file"
                  ref="input_logo"
                  v-show="false"
                  @change="mudarLogo"
                />
              </v-col>

              <v-col cols="12" sm="4" class="px-3 py-0">
                <v-card>
                  <v-img
                    :src="rodada.banner"
                    height="200px"
                    v-if="rodada.banner"
                    @click="$refs.dialogoBanner.abrir()"
                    style="cursor: pointer"
                  />
                  <v-layout
                    class="text-xs-center"
                    align-center
                    v-else
                    style="height:200px; background-color: lightgray; justify-content: center"
                  >
                    <v-icon large>image</v-icon>
                  </v-layout>

                  <v-card-title primary-title>
                    <div class="headline">Banner</div>
                    <v-spacer></v-spacer>
                    <v-btn
                      depressed
                      color="secondary darken-1"
                      type="file"
                      @click="abrirBanner"
                      v-show="podeEditar(rodada.data_fim)"
                      >Carregar</v-btn
                    >
                  </v-card-title>
                  <v-card-subtitle class="pt-2">
                    <span class="body-2"
                      >Carregue aqui o banner promocional do seu evento</span
                    >
                    <br />
                    <span class="grey--text" v-if="rodada.banner"
                      >Clique na imagem para ampliá-la</span
                    >
                  </v-card-subtitle>
                </v-card>
                <input
                  type="file"
                  ref="input_banner"
                  v-show="false"
                  @change="mudarBanner"
                />
              </v-col>

              <v-col cols="12" sm="4" class="px-3 py-0">
                <v-card>
                  <v-img
                    :src="rodada.planta"
                    height="200px"
                    v-if="rodada.planta"
                    @click="$refs.dialogoPlanta.abrir()"
                    style="cursor: pointer"
                  />
                  <v-layout
                    class="text-xs-center"
                    align-center
                    v-else
                    style="height:200px; background-color: lightgray; justify-content: center"
                  >
                    <v-icon large>image</v-icon>
                  </v-layout>

                  <v-card-title primary-title>
                    <div class="headline">Planta</div>
                    <v-spacer></v-spacer>
                    <v-btn
                      depressed
                      color="secondary darken-1"
                      type="file"
                      @click="abrirPlanta"
                      v-if="podeEditar(rodada.data_fim)"
                      >Carregar</v-btn
                    >
                  </v-card-title>
                  <v-card-subtitle class="pt-2">
                    <span class="body-2"
                      >Carregue aqui o planta do seu evento</span
                    >
                    <br />
                    <span class="grey--text" v-if="rodada.planta"
                      >Clique na imagem para ampliá-la</span
                    >
                  </v-card-subtitle>
                </v-card>
                <input
                  type="file"
                  ref="input_planta"
                  v-show="false"
                  @change="mudarPlanta"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
    </v-container>

    <as-dialogo ref="dialogoLogo" title="Logo" max-width="1200px">
      <v-img :src="rodada.logo" v-if="rodada.logo" height="600px" />
    </as-dialogo>

    <as-dialogo ref="dialogoBanner" title="Banner" max-width="1200px">
      <v-img :src="rodada.banner" v-if="rodada.banner" height="600px" />
    </as-dialogo>

    <as-dialogo ref="dialogoPlanta" title="Planta" max-width="1200px">
      <v-img :src="rodada.planta" v-if="rodada.planta" height="600px" />
    </as-dialogo>
  </div>
</template>

<script>
import Services from "@/services/services.js";
import ServiceRodadas from "@/services/rodadas.js";
import moment from "moment";

export default {
  name: "RodadasForm",
  data() {
    return {
      form_valid: false,
      rodada: {
        nome: "",
        local: "",
        data_inicio: "",
        data_fim: "",
        data_veiculacao: "",
        data_limite: "",
        cidade_id: 0,
        cidade_nome: "",
        estado_id: 0,
        estado_nome: "",
        administrador_id: 0,
        logo: "",
        banner: "",
        planta: "",
      },
      rules: {
        nome: [(value) => !!value || "Preenchimento obrigatório"],
        local: [(value) => !!value || "Preenchimento obrigatório"],
        data_inicio: [(value) => !!value || "Preenchimento obrigatório"],
        data_fim: [(value) => !!value || "Preenchimento obrigatório"],
        data_veiculacao: [(value) => !!value || "Preenchimento obrigatório"],
        data_limite: [(value) => !!value || "Preenchimento obrigatório"],
        cidade: [(value) => !!value || "Preenchimento obrigatório"],
        estado: [(value) => !!value || "Preenchimento obrigatório"],
        administrador: [(value) => !!value || "Preenchimento obrigatório"],
      },
      estados: [],
      cidades: [],
      administradores: [],
      loading: false,
      salvando: false,
      loadingCidades: false,
      user: {},
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user.tipo == "master") {
      this.carregarAdministradores();
    }
    if (this.$route.params.id) {
      this.abrir(this.$route.params.id);
    }
    if (!this.$route.params.id) {
      this.rodada.data_veiculacao = moment().format("YYYY-MM-DD");
      this.rodada.data_inicio = moment().format("YYYY-MM-DD");
      this.rodada.data_fim = moment().format("YYYY-MM-DD");
      this.rodada.data_limite = moment().format("YYYY-MM-DD");
      setTimeout(() => {
        this.form_valid = false;
      }, 100);
    }
  },
  created() {
    this.carregarEstados();
  },
  methods: {
    podeEditar(dataFim) {
      return new Date(dataFim) > new Date() || !this.rodada.id;
    },
    async abrir(rodada) {
      this.loading = true;
      let response = await ServiceRodadas.abrir(rodada);
      this.rodada = response.data.rodada;
      await this.carregarCidades();
      this.loading = false;
    },
    carregarEstados() {
      this.estados = Services.estados();
    },
    async carregarAdministradores() {
      this.loading = true;
      let response = await ServiceRodadas.carregarAdm();
      this.administradores = response.data.administradores;
      this.loading = false;
    },
    async carregarCidades() {
      this.loadingCidades = true;
      let response = await Services.cidades(this.rodada.estado_id);
      this.cidades = response.data.cidades;
      this.loadingCidades = false;
    },
    async salvarRodada() {
      if (this.$refs.form.validate()) {
        this.salvando = true;
        if (this.rodada.id) {
          try {
            await ServiceRodadas.atualizar(this.rodada, this.rodada.id);
            this.$eventbus.notificar("Rodada atualizada com sucesso");
          } catch (error) {
            console.log(error);
          } finally {
            this.salvando = false;
            this.$router.push("/rodadas");
          }
        } else {
          try {
            await ServiceRodadas.salvar(this.rodada);
            this.$eventbus.notificar("Rodada salva com sucesso");
          } catch (error) {
            console.log(error);
          } finally {
            this.salvando = false;
            this.$router.push("/rodadas");
          }
        }
      }
    },
    abrirLogo() {
      setTimeout(() => {
        this.$refs.input_logo.click();
      }, 1000);
    },
    mudarLogo() {
      let file = this.$refs.input_logo.files[0];

      let reader = new FileReader();
      reader.onload = () => {
        var dataURL = reader.result;
        this.rodada.logo = dataURL;
      };
      reader.readAsDataURL(file);
    },
    abrirBanner() {
      setTimeout(() => {
        this.$refs.input_banner.click();
      }, 1000);
    },
    mudarBanner() {
      let file = this.$refs.input_banner.files[0];

      let reader = new FileReader();
      reader.onload = () => {
        var dataURL = reader.result;
        this.rodada.banner = dataURL;
      };
      reader.readAsDataURL(file);
    },
    abrirPlanta() {
      setTimeout(() => {
        this.$refs.input_planta.click();
      }, 1000);
    },
    mudarPlanta() {
      let file = this.$refs.input_planta.files[0];

      let reader = new FileReader();
      reader.onload = () => {
        var dataURL = reader.result;
        this.rodada.planta = dataURL;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>

<style scoped>
/*  */
</style>
